import { useState, useCallback } from 'react';

export type FilterTabs = 'search' | 'saved-searches';

export const useFiltersTab = () => {
	const [currentTab, setCurrentTab] = useState<FilterTabs>('search');

	const handleChangeFilterTab = useCallback(
		(tab: FilterTabs) => {
			setCurrentTab(tab);
		},
		[setCurrentTab]
	);

	return { currentTab, handleChangeFilterTab };
};
